import { Search } from '@mui/icons-material';
import { Box, Divider, Grid, Typography } from '@mui/material';
import { ApiClient } from '~/api/Endpoints';
import { Link } from '~/components/Link';
import { ReportImage } from '~/components/ReportImage';
import { SummaryCard } from '~/components/SummaryCard';
import { useQuery } from '~/hooks/useQuery';
import { useSuggestions } from '~/hooks/useSuggestions';
import { useUser } from '~/hooks/useUser';
import { getNameFromSearch } from '~/scripts/getNameFromSearch';
import getReportImageUuid from '~/scripts/getReportImageUuid';
import type { Searches } from '~/types';

export default function RecentSearchesList() {
  const user = useUser();
  const api = new ApiClient();
  const { data: searches } = useQuery({
    queryKey: [user?.uuid],
    async queryFn() {
      if (user.isGuest !== false) {
        return null;
      }
      return api.get('/searches/history');
    },
  });

  if (!searches || !searches.length) {
    return null;
  }

  return (
    <>
      <Box>
        <Typography variant="h6" fontWeight={'bold'} sx={{ p: 1.9, pl: 4 }}>
          💡 Recent Searches
        </Typography>
      </Box>
      <Grid item xs={12}>
        <Divider />
      </Grid>
      <Grid item xs={12}></Grid>
      <Grid container item xs={12} spacing={1} sx={{ p: 3 }}>
        {searches?.slice(0, 6).map(({ uuid, search, url }) => {
          return <Item url={url} search={search} key={uuid} />;
        })}
      </Grid>
      <Grid item xs={12}>
        <Divider />
      </Grid>
    </>
  );
}

const Item = ({
  url,
  search,
}: {
  url: string;
  search: Searches.SearchObject;
}) => {
  const suggestions = useSuggestions();
  const name = getNameFromSearch(search, suggestions);
  const firstUuid = getReportImageUuid(search);
  return (
    <Grid item xs={12}>
      <Link underline={'none'} href={url}>
        <SummaryCard
          icon={<ReportImage uuid={firstUuid} height={25} width={25} />}
          title={name}
          subtitle={''}
          action={<Search />}
        />
      </Link>
    </Grid>
  );
};
